/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useEffect } from 'react';
import { useData } from '../Data';
import { useCourseData } from './CourseData';
import { LinkListSection, courseLabel, coursePicture } from '../UzlDesign';

export function TeachingSemester(props: any) {
  const { current, semesters, setType, lang } = useData();
  const { courses } = useCourseData();
  const [ current_semester, current_course ] = current ?? [null, null]

  useEffect(() => {
    setType(courses)
  }, [courses])

  const picture = courses.courses.map(coursePicture).find(Boolean);
  return (
    <div>
      <h1>{ courses.name }</h1>
      <LinkListSection image={picture}
        intro={<p>{lang === 'en' ? 'Lectures, seminars and lab courses of the institute in this semester.'
                                 : 'Vorlesungen, Seminare und Praktika des Instituts in diesem Semester.'}</p>}
        items={courses.courses.map((course: any) => ({
          ...courseLabel(course),
          href: `#${encodeURI(courses.id)}:${encodeURI(course.id)}`,
        }))} />
    </div>
  );
}
